import {
  tableTestAgentConfig,
  tableTestBrowserConfig,
  versionConfig
} from "./agent-browser-dropdown";

export const testExecutionColumns = [
  {
    key: "expand",
    showExpand: true,
    headerStyles: {
      color: "#ffffff",
      
      background: "#7593F2",
      width: "30px"
    }
  },
  {
    display_name: "",
    key: "select",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      
      padding: "4px 8px",
      width: "30px",
    },
    cellStyles: {
      width: "auto",
    },
    _config: {
      type: "checkbox",
      displayInColumn: true,
      value: "id",
      isClickable: "true",
    },
    hideForChildren: true,
  },
  {
    key: "planName",
    display_name: "Name",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
    },
  },
  {
    key: "caseName",
    display_name: "Test case Name",
    headerStyles: {
      background: "#7593F2",
      
      color: "#ffffff",
      padding: "4px 8px",
    },
  },
  {
    key: "version",
    display_name: "Version",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
      width: "15%"
    },
    _config: {
      type: "section_dropdown",
      targetKey: "selectedVersion",
      targetOptions: "versionList",
      componentInputs: {
        config: versionConfig,
        fields: [],
      },
    },
  },
  {
    key: "agent",
    display_name: "Execution Engine/Device",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
    },
    _config: {
      type: "menu_dropdown",
      targetKey: "selectedAgentDevice",
      componentInputs: {
        config: tableTestAgentConfig,
        fields: [
          {
            label: 'Devices',
            options: []
          },
          {
            label: 'Execution Engines',
            options: []
          }
        ],
      },
    },
  },
  {
    key: "browser",
    display_name: "Browser",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      width: "15%",
      padding: "4px 8px",
    },
    _config: {
      type: "section_dropdown",
      targetKey: "selectedBrowser",
      componentInputs: {
        config: tableTestBrowserConfig,
        fields: [],
      },
    },
  },
];
